import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=5968d17d&"
import script from "./IconButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./IconButton.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=5968d17d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports